import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { Camera } from 'types/camera';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

export function useCamera(
  id: string | null | undefined,
  { enabled, ...options }: UseQueryOptions<Camera, APIError> = {}
) {
  const { applicationID, client } = useAPI();

  return useAuthenticatedQuery(
    ['camera', id, applicationID],
    async () => {
      if (!id) {
        return Promise.reject('No camera id provided.');
      }

      const { data } = await client.get(`/apps/${applicationID}/cameras/${id}`);

      return data;
    },
    {
      ...options,
      enabled: enabled !== undefined ? Boolean(id) && enabled : Boolean(id),
    }
  );
}
